// extracted by extract-css-chunks-webpack-plugin
module.exports = {"xs":"667.98","sm":"947.98","md":"1023.98","lg":"1229.98","fabs":"-8ZiT3ac","fab":"_15srb5UH","fabImg":"V8jR1geQ"};